export default __webpack_public_path__ + "static/media/list_booth.eb2150d2.svg";